import React from 'react';
import {
  Container,
  Flex,
  useColorModeValue,
  Text,
  Center,
  useMediaQuery,
  Image,
} from '@chakra-ui/react';
import { useAuth } from '../../../providers/auth';
import Loader from '../../../components/Loader';

import logo from '../../../assets/images/logo_black.png';
import background from '../../../assets/images/fundo-login.png';
import RecoverForm from '../../../components/forms/RecoverForm';

export function RecoverPass() {
  const { loading } = useAuth();
  const [isSmallerThan1280] = useMediaQuery('(max-width: 767px)');

  if (loading) {
    return <Loader />;
  }

  return (
    <Flex
      direction={['column', 'row']}
      h="full"
      minH="100vh"
      bg={useColorModeValue('theme.light.body', 'theme.dark.body')}
    >
      {!isSmallerThan1280 && (
        <Flex w="full" minH="100vh" align="center" justify="center">
          <Flex align="center" justify="center">
            <Image maxH="300px" src={logo} />
          </Flex>
        </Flex>
      )}
      <Center
        w="full"
        minH="100vh"
        backgroundImage={background}
        backgroundSize="cover"
        bgRepeat="no-repeat"
        backgroundPosition="bottom center"
        backdropFilter="blur(8px)"
        borderBottomLeftRadius={15}
        borderTopLeftRadius={15}
        justifyContent="center"
      >
        <Container maxW="400px">
          <Text fontSize={22} color="#FAFAFA" mb="40px" fontWeight="600">
            Digite seu e-mail, no campo abaixo, para recuperar sua senha.
          </Text>
          <RecoverForm />
        </Container>
      </Center>
    </Flex>
  );
}
